<script>
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2025 (original work) Open Assessment Technologies SA ;

    import { __ } from '@oat-sa-private/ui-core';

    import { user } from '@/stores/auth.store';
    import { administrativeRoles } from '@/constants/roles';

    import { configurationStore } from '@/stores/tenantConfiguration.store';
    import { initialize as initializeAnalyticsService } from '@/services/analyticsService.js';
    import { ButtonLink } from '@oat-sa-private/ui-elements';
    import { CookiePolicy } from '@oat-sa-private/ui-components';

    import { cookiePolicyConfig } from '@/components/CookiePolicyWrapper/cookiePolicyConfig';
    import { createCookieStorage } from 'util/cookies.js';

    const userData = user.get();
    const tenantData = configurationStore.getCurrentTenant();
    const cookiePolicyConfiguration = configurationStore.getCookiePolicyConfiguration();

    const userId = userData?.userId;
    const userRoles = userData?.roles;
    const tenantId = tenantData?.tenantId;
    const storage = createCookieStorage({ domainLevel: 2 });
    const config = cookiePolicyConfig();

    function handleInitializeCookies(event) {
        if (event.detail?.analytics) {
            initializeAnalyticsService(userData, tenantData, configurationStore.getUserpilotConfiguration());
        }
    }

    config.privacyPolicyLink.url = cookiePolicyConfiguration?.privacyPolicyLink || config.privacyPolicyLink.url;
    config.cookiePolicyLink.url = cookiePolicyConfiguration?.cookiePolicyLink || config.cookiePolicyLink.url;
    config.display = cookiePolicyConfiguration?.display ?? config.display;
</script>

<style>
    @media print {
        :global(#page > .notification-wrapper) {
            display: none !important;
        }
        :global(.cookie-policy-underline) {
            display: none !important;
        }
    }
</style>

{#if userId && tenantId && config && config.display && userRoles && administrativeRoles.some( item => userRoles.includes(item) )}
    <CookiePolicy
        storageId={`${tenantId}-${userId}`}
        {storage}
        title={config.title}
        message={config.message}
        options={config.options}
        on:initializeCookies={handleInitializeCookies}>
        <div slot="additional-text">
            {__('You can read more about this in our')}&nbsp;
            <ButtonLink href={config.privacyPolicyLink.url} title={config.privacyPolicyLink.label} target="_blank" />
            &nbsp;{__('and')}&nbsp;
            <ButtonLink href={config.cookiePolicyLink.url} title={config.cookiePolicyLink.label} target="_blank" />
        </div>
    </CookiePolicy>
{/if}
